
import { useTranslation } from 'react-i18next';

export default function ContactInfo() {
  const { t } = useTranslation('contact');

  return (
    <div className="bg-white py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-[#0D1B2A] mb-4">
            {t('info.title')}
          </h2>
          <p className="text-xl text-[#394B59] max-w-3xl mx-auto">
            {t('info.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Address */}
          <div className="text-center">
            <div className="w-16 h-16 bg-[#2E8BC0]/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-map-pin-line text-3xl text-[#2E8BC0]"></i>
            </div>
            <h3 className="text-xl font-bold text-[#0D1B2A] mb-3">{t('info.address')}</h3>
            <p className="text-[#394B59] leading-relaxed">
              {t('info.addressValue')}
            </p>
          </div>

          {/* Invoicing Address */}
          <div className="text-center">
            <div className="w-16 h-16 bg-[#2E8BC0]/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-file-text-line text-3xl text-[#2E8BC0]"></i>
            </div>
            <h3 className="text-xl font-bold text-[#0D1B2A] mb-3">{t('info.invoicing')}</h3>
            <p className="text-[#394B59] leading-relaxed">
              {t('info.invoicingValue')}
            </p>
          </div>

          {/* Email */}
          <div className="text-center">
            <div className="w-16 h-16 bg-[#2E8BC0]/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-mail-line text-3xl text-[#2E8BC0]"></i>
            </div>
            <h3 className="text-xl font-bold text-[#0D1B2A] mb-3">{t('info.email')}</h3>
            <a 
              href="mailto:office@bulkcomsro.com" 
              className="text-[#2E8BC0] hover:text-[#1F5F8B] transition-colors duration-300 text-lg cursor-pointer"
            >
              office@bulkcomsro.com
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
